import server from "../Server";
import { AuthMePayload } from "../../../gateways";
import { IUser } from "@grassrootly/api/entities";

export const AuthMe = async (params: AuthMePayload): Promise<IUser | null> => {
  await server.auth.signOut();
  const { data } = await server.auth.getUser(params.access_token);
  if (!data || !data.user) {
    return null;
  }
  return {
    ...data.user,
    uid: data.user.id,
    email: data.user.email || "",
  };
};
